import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';

import { useAuth } from 'context/AuthProvider.js';
import { useNavigate } from 'react-router-dom';
import FiltersDashboard from './_FiltersDashboard.js';
import HeaderStatus from './_HeaderStatus.js';
import { httpClient } from 'helpers/HttpClient.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import QuejasList from 'pages/Operations/QuejasList.js';
import { FormatDateStr, FormatDateToDb } from 'helpers/FormatData.js';
const URI = ApiEndpoint + 'operations/';

const Dashboard = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [loadData, setLoadData] = useState(false);
  const [filters, setFilters] = useState({
    idCustomer: 0,
    dateFrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    dateTo: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
    idStatus: 0
  });
  const [dataSmry, setDataSmry] = useState(new Date());
  const [dataList, setDataList] = useState(new Date());
  let history = useNavigate();
  useEffect(() => {
    var authCheck = Auth.getSessionData();
    if (!authCheck || authCheck?.length === 0 || authCheck === 'null') {
      history('/security/login');
      return;
      //Router.push('/login');
    } else {
      ///account/validate
      httpClient('POST', ApiEndpoint + 'account/validate', {}, userData.token)
        .then(function (response) {
          if (!response.data.error) {
            setDataSmry(response.data);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(() => {});
      setLoadData(true);
    }
  }, []);

  const getSmry = async () => {
    if (!loadData) return;
    setDataSmry(null);

    httpClient(
      'POST',
      URI + 'summarybystatus/',
      {
        idcustomer: filters.idCustomer || 0,
        from: FormatDateToDb(filters.dateFrom),
        to: FormatDateToDb(filters.dateTo)
      },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setDataSmry(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  function changeStatus(idStatus) {
    setFilters({ ...filters, idStatus: idStatus });
  }
  const getQuejasList = async () => {
    if (!loadData) return;
    setDataList(null);

    httpClient(
      'POST',
      URI + 'summaryquejas/',
      {
        idcustomer: filters.idCustomer || 0,
        from: filters.dateFrom,
        to: filters.dateTo,
        idstatus: filters.idStatus || 0
      },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          setDataList(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  useEffect(() => {
    if (!loadData) return;
    if (filters) {
      getSmry();
      getQuejasList();
    }
  }, [filters.dateFrom, filters.dateTo, filters.idCustomer]);

  useEffect(() => {
    if (!loadData) return;
    getQuejasList();
  }, [filters.idStatus]);

  return (
    <>
      {userData && (
        // Se agregó estilo inline para aplicar márgenes y padding interno al Card
        <Card
          className="bg-100 shadow-none border mb-3"
          style={{
            margin: '12px', // Margen externo (separación con otros elementos)
            padding: '16px' // Padding interno (espaciado del contenido hacia adentro)
          }}
        >
          <Card.Header className="py-0" style={{ padding: '8px 0 16px 0' }}>
            <Row>
              <Col md={12}>
                <FiltersDashboard
                  action={() => {}}
                  setLoadData={setLoadData}
                  setFilters={setFilters}
                />
              </Col>
            </Row>
          </Card.Header>
          {dataSmry && (
            <>
              <HeaderStatus
                changeStatus={changeStatus}
                dataSmry={dataSmry}
              ></HeaderStatus>
            </>
          )}
          {dataList && (
            <>
              <QuejasList
                subTitle={`Periodo: ${FormatDateStr(
                  filters.dateFrom
                )} - ${FormatDateStr(filters.dateTo)} `}
                dataReport={dataList}
              ></QuejasList>
            </>
          )}
        </Card>
      )}
    </>
  );
};

export default Dashboard;
